import BadgeRow from './BadgeRow';

export default BadgeRow;
